export default __webpack_public_path__ + "static/media/services7.0a473fe1.jpg";